import React from 'react';
import { Link } from 'react-router-dom';

function DashboardCard({ title, value, subtitle, icon, to, onClick, accent = 'blue' }) {
  const content = (
    <>
      <div className="hr-stat-card-top">
        <span className="hr-stat-card-icon">{icon}</span>
        <span className={`hr-stat-card-accent hr-stat-accent-${accent}`} />
      </div>
      <p className="hr-stat-card-label">{title}</p>
      <h3 className="hr-stat-card-value">{value ?? '—'}</h3>
      {subtitle ? <p className="hr-stat-card-subtitle">{subtitle}</p> : null}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="hr-stat-card hr-stat-card-link"
        aria-label={`${title}: ${value ?? 0}. View matching records.`}
      >
        {content}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button
        type="button"
        className="hr-stat-card hr-stat-card-button"
        onClick={onClick}
        aria-label={`${title}: ${value ?? 0}. View matching records.`}
      >
        {content}
      </button>
    );
  }

  return <div className="hr-stat-card">{content}</div>;
}

export default DashboardCard;
